import { useSelector } from "react-redux";

const useUserType = () => {
  const user = useSelector((state) => state.user?.user);
  const userTypeId = user?.user_type?.id;

  return {
    isStudent: userTypeId === 1,
    isParent: userTypeId === 2,
    isSchool: userTypeId === 3,
    isTeacher: userTypeId === 4,
    isSuper: userTypeId === 5, // Assuming ID 5 for Super Admin if it exists
    isKid: userTypeId === 6, // Assuming ID 6 for Kid if it exists
  };
};

export default useUserType;
